import { Component, DoCheck, ViewChild, Input, Output, EventEmitter } from '@angular/core'
import { StepDto, ValidationContent } from '../../../../models/StepDTO';
import { NgForm } from '@angular/forms';


@Component({
  selector: 'wdm-qrCode-form',
  styleUrls: ['../../../../styles/components/steps.scss'],
  templateUrl: 'qrCode-form.component.html',
})

export class QrCodeFormComponent  implements DoCheck {

  @ViewChild('qrCodeForm', {static: true}) private qrCodeForm: NgForm;
  @Input() stepInfo: StepDto;
  @Output() errors: EventEmitter<boolean> = new EventEmitter<boolean>(true);

  numberOperations: string[] = [null, '=', '<', '>', '<=', '>='];
  content: ValidationContent = new ValidationContent();

  constructor() {
  }

  ngOnInit() {
    if (this.stepInfo.content != null) {
      this.content = JSON.parse(this.stepInfo.content);
    }
  }

  ngDoCheck(): void {
    
    if (this.qrCodeForm.status === 'INVALID') {
      this.errors.emit(true);
    } else {
      this.stepInfo.state = "OK";
      this.errors.emit(false);
      if (this.stepInfo?.content !== null) {
        this.stepInfo.content = JSON.stringify(this.content);
      }
    }
  }

  forceValidation() {
    this.qrCodeForm.controls.title.markAsTouched();
    this.qrCodeForm.controls.description.markAsTouched();
    this.qrCodeForm.controls.operation.markAllAsTouched();
    this.qrCodeForm.controls.validationValue.markAllAsTouched();
  }

  preventComas(event) {
    if (event.key === ",") event.preventDefault();
  }
}
